import React from "react";
import { signOut } from "firebase/auth";
import { auth } from "../firebase";

export default function AccessDenied() {
  return (
    <main className="min-h-screen bg-slate-50 flex items-center justify-center p-6">
      <div className="w-full max-w-lg rounded-2xl border bg-white p-8 shadow-sm text-center">
        <h1 className="text-2xl font-semibold text-slate-900">Access not provisioned</h1>
        <p className="mt-3 text-sm leading-6 text-slate-600">
          This login exists in Firebase Authentication but is not linked to an active Pravah staff or client portal profile.
          Please contact the administrator.
        </p>
        <button type="button" className="mt-6 rounded-lg bg-[#0B1F33] px-5 py-2.5 font-semibold text-white" onClick={() => signOut(auth)}>
          Sign out
        </button>
      </div>
    </main>
  );
}
